import { Injectable } from '@angular/core';
import {
  FormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import { FormControlTemplate } from './form.model';

import reduce from 'lodash-es/reduce';

@Injectable()
export class FormService {
  constructor(private formBuilder: UntypedFormBuilder) {}

  public generateFormGroup(
    forms: FormControlTemplate[],
    validators?: any[],
  ): UntypedFormGroup {
    const formGroupConfig = this._generateFormGroupConfigs(forms);
    return validators
      ? this.formBuilder.group(formGroupConfig, { validator: validators })
      : this.formBuilder.group(formGroupConfig);
  }

  public generateFormControl(form: any): UntypedFormControl {
    const formControlConfig: any = this._generateFormControlConfig(form);
    return new UntypedFormControl(...formControlConfig);
  }

  public moveItemInFormArray(
    formArray: FormArray,
    fromIndex: number,
    toIndex: number,
  ) {
    if (!Number.isInteger(fromIndex) || !Number.isInteger(toIndex)) {
      return;
    }
    const from = this._clampIntegersToMax(fromIndex, formArray.length - 1);
    const to = this._clampIntegersToMax(toIndex, formArray.length - 1);
    if (from === to) {
      return;
    }
    const previous = formArray.at(from);
    const current = formArray.at(to);
    formArray.setControl(to, previous);
    formArray.setControl(from, current);
  }

  private _clampIntegersToMax(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }

  private _generateFormGroupConfigs(forms: any[]): any {
    return reduce(
      forms,
      (result: any, form: any) => {
        if (!form.updateKey) {
          return result;
        }
        if (form.formGroup) {
          return {
            ...result,
            [form.updateKey]: this.generateFormGroup(
              form.formGroup,
              form.validators,
            ),
          };
        }
        return {
          ...result,
          [form.updateKey]: this._generateFormControlConfig(form),
        };
      },
      {},
    );
  }

  private _generateFormControlConfig(form: FormControlTemplate): any {
    const formControlValue: any[] = [
      { value: form.model, disabled: form.disable },
    ];
    return form.validators
      ? [...formControlValue, form.validators]
      : formControlValue;
  }
}
